import styled from 'styled-components';

const AssignButtonWrapper = styled.div`
  position: relative;
`;

export default AssignButtonWrapper;